export default __webpack_public_path__ + "static/media/godrejInfoTechLogo.e5d7a5c3.svg";